import React from "react";
import { Box } from '@mui/joy';
import { useTranslation } from 'react-i18next';
import AccettateRankingTableSet from "./AccettateRanking.TableSet";
import AccettateAnalisiKPISet from "../accettateAnalisi/AccettateAnalisi.KPISet";

const AccettateRanking = ({ dataProviderName, filters, $key }) => {
    const { t } = useTranslation();

    const showKPI = true;
    const showAccettateRanking = true;

    return (
        <Box className="dashboard-page" key={$key}>
            <Box className="dashboard-page-title">
                <h2>{t('Accettate')}</h2>
            </Box>

            {showKPI &&
                <Box className="report-itemgroup">
                    <AccettateAnalisiKPISet dataProviderName={dataProviderName} filters={filters} />
                </Box>
            }

            {showAccettateRanking &&
                <AccettateRankingTableSet dataProviderName={dataProviderName} filters={filters} />
            }
        </Box>
    );
};

export default AccettateRanking;
